import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { SpecraButton } from '@mono/ui-components';
import { Testids } from '@mono/ui-selectors';
import { useState } from 'react';
import { downloadDocx, rfiEvidenceApi } from './api';
/** Outward bytes always come from the protected renderer, never the editor or a cached receipt. */ export function RfiOutwardExport({ target, api = rfiEvidenceApi }) {
    const [busy, setBusy] = useState(false);
    const [error, setError] = useState('');
    return /*#__PURE__*/ _jsxs(_Fragment, {
        children: [
            /*#__PURE__*/ _jsx(SpecraButton, {
                variant: "secondary",
                "data-testid": Testids.rfiEvidence.exportCurrent,
                disabled: busy,
                onClick: async ()=>{
                    setBusy(true);
                    setError('');
                    try {
                        downloadDocx(await api.outwardCurrent(target), 'rfi-reviewed-outward.docx');
                    } catch (err) {
                        setError(err instanceof Error ? err.message : 'Outward export unavailable. Retry after reviewing the saved answer.');
                    } finally{
                        setBusy(false);
                    }
                },
                children: busy ? 'Checking outward evidence…' : 'Export reviewed outward DOCX'
            }),
            error && /*#__PURE__*/ _jsx("output", {
                role: "alert",
                children: error
            })
        ]
    });
}
